module.exports = __webpack_public_path__ + "img/flood_sensor_alert.8f2b1a15.svg";